import * as Sentry from '@sentry/react';

const shouldReportToSentry = (): boolean => {
  if (['local-dev', 'development'].includes(process.env.NODE_ENV || '')) {
    return false;
  }
  return true;
};

const isSentryEnabled = (): boolean => {
  if (shouldReportToSentry()) {
    return true;
  }
  console.warn(`Sentry reporting is disabled in ${process.env.NODE_ENV} environment`);
  return false;
};

const reportException = (error: unknown, context: string): void => {
  if (shouldReportToSentry()) {
    Sentry.captureException(error, { tags: { context } });
    return;
  } else {
    console.error(`[${context}]`, error);
  }
};

const reportMessage = (message: string, context: string, level: 'error' | 'warning' = 'error'): void => {
  if (shouldReportToSentry()) {
    Sentry.captureMessage(message, { level, tags: { context } });
    return;
  } else {
    const formatted = `[${context}] ${message}`;
    if (level === 'warning') {
      console.warn(formatted);
      return;
    }
    console.error(formatted);
  }
};

export { isSentryEnabled, shouldReportToSentry, reportMessage, reportException };
